module.exports = __webpack_public_path__ + "static/media/3.b28d24ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/novopolotsk/3.jpg
// module id = 245
// module chunks = 0